//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'dayjs'
import showMask from '@/components/mask/mask.vue'
export default {
	data() {
		return {
			myComplainList: [],
			page: {
				pageSize: 10,
				currentPage: 1,
				count: 0,
				loading: false,
				finished: false
			},
			id: '',
			repealList: ['我弄错了', '问题已经解决', '不需要解决'],
			score: '',
			auditModal: false,
			activeIndex: '-1',
			content: '',
		}
	},
	components: {
		showMask
	},
	onLoad() {



	},
	onShow() {
		this.myComplainList = []
		this.page.currentPage = 1
		this.queryData()
	},
	onPullDownRefresh() {
		this.myComplainList = []
		this.page.currentPage = 1
		this.queryData()
	},
	onReachBottom() {
		if (this.myComplainList.length < this.page.count) {
			this.queryData()
		}
	},
	methods: {
		formatTime(d) {
			if (d === null || d === '') {
				return ''
			} else {
				return moment(d).format('YYYY年MM月DD日')
			}
		},
		phone() {
			uni.makePhoneCall({
				phoneNumber: this.$store.state.storeConfig.serverPhone //仅为示例
			})
		},
		//弹框选项
		modalShow(index, content) {
			this.activeIndex = index
			this.content = content
		},
		cancelRepeal() {
			this.activeIndex = '-1'
			this.content = ''
			this.auditModal = false
		},
		queryData() {
			this.page.loading = true
			if (this.$store.state.userInfo.memberId) {
				this.$ajax({
					method: 'post',
					url: '/weChat/cms/complaint/queryByConditions',
					data: {
						memberId: this.$store.state.userInfo.memberId,
						...this.page
					}
				}).then(res => {
					res.data.forEach(t => {
						t.publish_time = moment(t.publish_time).format('YYYY-MM-DD')
						t.context = decodeURI(t.context)
					})
					this.page.count = res.count
					this.page.currentPage += 1
					this.myComplainList.push(...res.data)
					if (this.myComplainList.length >= this.page.count) {
						this.page.finished = true
					} else {
						this.page.finished = false
					}
					this.page.loading = false
				})
			}
		},
		//撤销
		repeal(id) {
			this.auditModal = true
			this.id = id
		},
		// 撤销
		handelRepeal() {
			if (this.activeIndex === '-1') {
				uni.showToast({
					title: '请选择原因',
					icon: 'none'
				})
			} else {
				this.$ajax({
					method: 'post',
					url: '/weChat/cms/complaint/updateCancel',
					data: {
						id: this.id
					}
				}).then(res => {
					this.auditModal = false
					this.cancelRepeal()
					this.myComplainList = []
					this.page.currentPage = 1
					this.queryData()
				})

			}
		}
	}
}
